export default __webpack_public_path__ + "static/16073-fb09dc552b8032c959655ea2a7766a07.jpg";